/**
 * Number formatting using d3-format library
 */
import { format } from 'd3-format'

export function formatThousandsNoDecimal (value) {
  return format(",.0f")(value)
}

export function formatNoDecimalIfExists (value) {
  return (value !== null && value !== undefined && value !=="")? format(",.0f")(value) : ""
}

export function formatPercentIfExists (value) {
  return (value !== null && value !== undefined && value !=="")? format(".1%")(value) : ""
}

export function formatPercentNoDecimalIfExists (value) {
  return (value !== null && value !== undefined && value !=="")? format(".0%")(value) : ""
}

export function formatOneDecimalIfExists (value) {
  return (value !== null && value !== undefined && value !=="")? format(",.1f")(value) : ""
}

export function getNumberWithOrdinal(n) { //https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
  var s = ["th", "st", "nd", "rd"],
      v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function percentToOneInX (percent) {
  /**
   * Takes a decimal percent number (i.e. 0.127) and converts it to a string like "1 in 10" or "1 in 8".
   * @param {number}  percent   Number as decimal percent
   * @return {string}
   */
  
  const pct = percent;

  if (pct > 0.38 && pct < 0.45) {
    return "2 in 5"
  } else if (pct <= 0.58) {
    return `1 in ${Math.round(1 / pct)}`
  } else if (pct <= 0.64) {
    return "3 in 5"
  } else if (pct <= 0.72) {
    return "2 in 3"
  } else if (pct <= 0.78) {
    return "3 in 4"
  } else if (pct <= 0.87) {
    return "4 in 5"
  } else if (pct <= 0.93) {
    return "9 in 10"
  } else {
    // fallback to percent string (rounded)
    return `${Math.round(pct * 100)}%`
  }
}